import { UI, HStack } from '@genial/components';
import { BoxBorder, Color, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';
import { FlatList } from 'react-native';

import { LoadingTable } from '../LoadingTable';

import { desktopMaxHeight, tableHead, desktopWidthCols } from './constants';

import { PlatformQueryContainerDataProps } from '.';

export const ProductItemDesktopWrapper: React.FC = () => (
  <Box w="full" h="1px" bgColor={Color['neutral.lightest']} />
);

interface ProductItemProps {
  item: PlatformQueryContainerDataProps['data'][0];
}

export const ProductItemDesktop: React.FC<ProductItemProps> = ({ item }) => {
  return (
    <HStack my={Spacing['stack.xxxs']}>
      <UI.TableItem testId={'table-product-toolName'} width={desktopWidthCols.platform}>
        <UI.Text>{item.toolName}</UI.Text>
      </UI.TableItem>
      <UI.TableItem testId={'table-product-packageName'} width={desktopWidthCols.package}>
        <UI.Text>{item.packageName}</UI.Text>
      </UI.TableItem>
      <UI.TableItem testId={'table-product-hiringDate'} width={desktopWidthCols.initialDate}>
        <UI.Text>{Utils.Mask.DateFormat(item.hiringDate, 'dd/MM/yyyy - HH:mm:ss')}</UI.Text>
      </UI.TableItem>
      <UI.TableItem testId={'table-product-cancelDate'} width={desktopWidthCols.finalDate}>
        <UI.Text>
          {item.cancelDate ? Utils.Mask.DateFormat(item.cancelDate, 'dd/MM/yyyy - HH:mm:ss') : '--'}
        </UI.Text>
      </UI.TableItem>
      <UI.TableItem
        testId={'table-product-hiringStateDescription'}
        width={desktopWidthCols.adhesionStatus}>
        <UI.Text>{item.hiringStateDescription}</UI.Text>
      </UI.TableItem>
    </HStack>
  );
};

export const ContentDesktop: React.FC<PlatformQueryContainerDataProps> = ({ isLoading, data }) => {
  return (
    <UI.Shadow
      level={1}
      borderRadius={BoxBorder.heavy}
      my={Spacing['inset.sm']}
      paddingX={Spacing['inline.xxxs']}
      paddingY={Spacing['inline.xxs']}
      pb={0}>
      <UI.Table testId="table-customers-ties" isLoading={false} cols={3} rows={5}>
        <UI.TableHead testId="table-customers-ties-head">
          {Object.entries(tableHead).map((tableHeadItem, index) => {
            const width = Object.entries(desktopWidthCols).map((col) => col[1])[index];

            return (
              <UI.TableTitle
                key={tableHeadItem[0]}
                testId={`table-customers-ties-title-${index}`}
                width={width}>
                {tableHeadItem[1] as string}
              </UI.TableTitle>
            );
          })}
        </UI.TableHead>

        {isLoading ? (
          <LoadingTable columns={5} />
        ) : (
          <FlatList
            windowSize={20}
            maxToRenderPerBatch={20}
            updateCellsBatchingPeriod={5}
            data={data}
            ItemSeparatorComponent={ProductItemDesktopWrapper}
            contentContainerStyle={{ maxHeight: desktopMaxHeight }}
            // ListEmptyComponent={<LoadingTable columns={columns} />}
            showsVerticalScrollIndicator={false}
            // onEndReached={handleEndReached}
            onEndReachedThreshold={1.5}
            // ListFooterComponent={loadingFooter}
            renderItem={({ item }) => <ProductItemDesktop item={item} />}
          />
        )}
      </UI.Table>
    </UI.Shadow>
  );
};
